const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const invoiceText = (inv, projectName) =>
  `SITERA — Invoice ${inv.invoice_number}\n` +
  (projectName ? `Project: ${projectName}\n` : "") +
  `Amount: ${money(inv.amount)}\nTax: ${money(inv.tax_amount)}\nTotal: ${money(inv.total)}\n` +
  `Paid: ${money(inv.paid_amount)}\nBalance Due: ${money(inv.balance_due)}\n` +
  `Issue Date: ${inv.issue_date || "—"}\nDue Date: ${inv.due_date || "—"}\nStatus: ${inv.status}` +
  (inv.description ? `\nNote: ${inv.description}` : "");

export const shareInvoiceWhatsApp = (inv, projectName) =>
  window.open(`https://wa.me/?text=${encodeURIComponent(invoiceText(inv, projectName))}`, "_blank", "noopener");

export const shareInvoiceEmail = (inv, projectName) => {
  window.location.href = `mailto:?subject=${encodeURIComponent(`Invoice ${inv.invoice_number} — SITERA`)}&body=${encodeURIComponent(invoiceText(inv, projectName))}`;
};

export const printInvoice = (inv, projectName, clientName) => {
  const w = window.open("", "_blank", "width=820,height=980");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>Invoice ${inv.invoice_number}</title>
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #18181b; padding: 40px; }
  .head { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 4px solid #f97316; padding-bottom: 16px; margin-bottom: 24px; }
  .brand { font-size: 26px; font-weight: 900; letter-spacing: 2px; }
  .brand span { color: #f97316; }
  .inv-no { font-size: 20px; font-weight: 700; text-align: right; }
  .status { display: inline-block; margin-top: 6px; padding: 3px 10px; border: 1px solid #18181b; font-size: 11px; letter-spacing: 1px; text-transform: uppercase; }
  .meta { display: flex; gap: 40px; margin-bottom: 24px; font-size: 13px; }
  .meta b { display: block; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: #71717a; margin-bottom: 3px; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
  th { text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color: #71717a; border-bottom: 2px solid #18181b; padding: 8px 6px; }
  td { padding: 10px 6px; border-bottom: 1px solid #e4e4e7; font-size: 14px; }
  td.r, th.r { text-align: right; }
  .totals { margin-left: auto; width: 280px; font-size: 14px; }
  .totals div { display: flex; justify-content: space-between; padding: 6px 0; }
  .totals .grand { border-top: 2px solid #18181b; font-weight: 800; font-size: 16px; }
  .balance { color: #dc2626; font-weight: 700; }
  .foot { margin-top: 48px; font-size: 11px; color: #71717a; border-top: 1px solid #e4e4e7; padding-top: 12px; }
  @media print { body { padding: 20px; } }
</style></head><body>
  <div class="head">
    <div class="brand">BUILD<span>CORE</span><div style="font-size:11px;font-weight:400;letter-spacing:1px;color:#71717a;margin-top:4px">CONSTRUCTION PORTAL</div></div>
    <div class="inv-no">INVOICE ${inv.invoice_number}<br/><span class="status">${inv.status}</span></div>
  </div>
  <div class="meta">
    ${projectName ? `<div><b>Project</b>${projectName}</div>` : ""}
    ${clientName ? `<div><b>Billed To</b>${clientName}</div>` : ""}
    <div><b>Issue Date</b>${inv.issue_date || "—"}</div>
    <div><b>Due Date</b>${inv.due_date || "—"}</div>
  </div>
  <table>
    <tr><th>Description</th><th class="r">Amount</th></tr>
    <tr><td>${inv.description || "Construction work — progress billing"}</td><td class="r">${money(inv.amount)}</td></tr>
    <tr><td>Tax</td><td class="r">${money(inv.tax_amount)}</td></tr>
  </table>
  <div class="totals">
    <div><span>Total</span><span>${money(inv.total)}</span></div>
    <div><span>Paid</span><span>${money(inv.paid_amount)}</span></div>
    <div class="grand"><span>Balance Due</span><span class="balance">${money(inv.balance_due)}</span></div>
  </div>
  <div class="foot">Generated by Sitera Construction Portal · sitera.in · ${new Date().toLocaleDateString("en-IN")}</div>
</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 400);
};
